"use strict";

define('model/message.tag',['./base'], function (Base) {
  var MessageTag = Base.extend({
    virtual: {
      'tagName': function tagName() {
        return '[' + this.get('name') + ']';
      },
      'macro': function macro() {
        return this.get('tagName');
      }
    }
  }, {
    allByNotificationKind: function allByNotificationKind(messageTemplateId, addressable) {
      return this.createCollection('/rs/api/messageTemplate/tags/:messageTemplateId/:addressable').params({
        messageTemplateId: messageTemplateId,
        addressable: !!addressable
      });
    }
  });
  return MessageTag;
});

